import { render, staticRenderFns } from "./CardSectionDetails.vue?vue&type=template&id=e354e1e8&"
import script from "./CardSectionDetails.vue?vue&type=script&lang=js&"
export * from "./CardSectionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports